import { Button, ButtonMode, Checkbox, Icon, ICONS, Popup, Tooltip } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import { NotificationMode } from '../../../../../models/Preference';
import styles from './AlertPopup.module.scss';

const cx = classNames.bind(styles);

interface AlertPopupProps {
  alert: NotificationMode;
  selectAlert: (alert: NotificationMode) => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isDisabled: boolean;
}

const AlertPopup = ({ alert, selectAlert, isOpen, setIsOpen, isDisabled }: AlertPopupProps): React.ReactElement => {
  const onAlertChange = (_, data) => {
    selectAlert(data.value);
  };

  const renderTriggerButton = () => (
    <div>
      <Tooltip
        trigger={
          <Button
            className={cx('popup-trigger-button')}
            dataTestId="watchlist-alert-button"
            mode={ButtonMode.TERTIARY}
            ariaLabel="Alert"
            hasEqualSidesPadding
            disabled={isDisabled}
          >
            <Icon
              name={alert === NotificationMode.None ? ICONS.BellCrossed : ICONS.Bell}
              dataTestId="watchlist-alert-button-icon"
            />
            <span className={cx('caret-icon', { rotate: isOpen })}>
              <Icon name={ICONS.CaretDown} width={9} />
            </span>
          </Button>
        }
        content={alert}
        disabled={isOpen}
      />
    </div>
  );

  return (
    <Popup
      className={cx('body')}
      trigger={renderTriggerButton()}
      on="click"
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      position="bottom right"
      data-testid="watchlist-alert-popup"
      disabled={isDisabled}
    >
      <div className={cx('content')}>
        <span className={cx('title')}>Alerts</span>
        <Checkbox
          className={cx('radio-select')}
          radio
          label="Digest"
          name="alertsGroup"
          value={NotificationMode.Digest}
          checked={alert === NotificationMode.Digest}
          onChange={onAlertChange}
          dataTestId="alert-digest-radio-button"
          aria-label="Digest"
        />
        <Checkbox
          className={cx('radio-select')}
          radio
          label="Instant"
          name="alertsGroup"
          value={NotificationMode.Instant}
          checked={alert === NotificationMode.Instant}
          onChange={onAlertChange}
          dataTestId="alert-instant-radio-button"
          aria-label="Instant"
        />
        <Checkbox
          className={cx('radio-select')}
          radio
          label="None"
          name="alertsGroup"
          value={NotificationMode.None}
          checked={alert === NotificationMode.None}
          onChange={onAlertChange}
          dataTestId="alert-none-radio-button"
          aria-label="None"
        />
      </div>
    </Popup>
  );
};

export default AlertPopup;
